class VwHbsHastaMuayeneDTO {
    id: number = 0;
    muracaatId?: number = null;
    tarih?: string = null;
    hastaservisId?: number = null;
    bransId?: number = null;
    raporId?: number = null;
    rapor?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    servisAdi?: string = "";
    doktorAdi?: string = "";
    kimlikId?: number = null;
    adi?: string = "";
    sira?: number = null;
    tarihaktif?: string = "";
};
export default VwHbsHastaMuayeneDTO;